export function paymentLinkErrorMessage(error, checkout = false) {
  const status = error?.response?.status;
  if ([400, 404, 410, 422].includes(status)) return 'This payment link is invalid or has expired.';
  if ([401, 403].includes(status)) return 'This payment link is no longer available.';
  if (status === 429) return 'Too many attempts. Wait a few minutes, then refresh this page to try again.';
  return checkout
    ? 'Checkout could not be opened. Refresh this page to try again.'
    : 'Your payment details could not be loaded. Refresh this page to try again.';
}
